// extracted by mini-css-extract-plugin
export var borderRadius = "_b7-4";
export var large = "_b7-3";
export var logoContainer = "_b7-0";
export var nameLogo = "_b7-2";
export var small = "_b7-1";